import { render } from "./PanelEditor.vue?vue&type=template&id=e4da3e16"
import script from "./PanelEditor.vue?vue&type=script&lang=js"
export * from "./PanelEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__